/**
 * 设备管理路由
 */
 const Layout = () => import(/* webpackChunkName: "Layout" */'@serviceapp/deviceManage/Router.vue')
 export default [
     {
         path: '/deviceManage',
         name: 'deviceManage',
         component: Layout,
         meta: { text: '综合运维' },
         children: [
             {
                 path: 'dataView',
                 name: 'dataView',
                 component: () => import(/* webpackChunkName: "dataView" */'@serviceapp/deviceManage/dataView/Index.vue'),
                 meta: { text: '统计概览' }
             },
             {
                path: 'manage',
                name: 'manage',
                component: () => import(/* webpackChunkName: "manage" */'@serviceapp/deviceManage/manage/Index.vue'),
                meta: { text: '设备管理' }
            },
            {
                path: 'deviceData',
                name: 'deviceData',
                component: () => import(/* webpackChunkName: "deviceData" */'@serviceapp/deviceManage/deviceData/Index.vue'),
                meta: { text: '设备数据' }
            }
         ]
     },
 ]